import AsyncStorage from "@react-native-async-storage/async-storage";
import { decrypt, encrypt } from "./crypt";

export const getStorage = async (key = "root-storage"): Promise<any> => {
  try {
    const storage = await AsyncStorage.getItem(key);

    return storage === null ? undefined : JSON.parse(storage);
  } catch (error) {
    return undefined;
  }
};

export const saveStorage = async (state: any, key = "root-storage"): Promise<void> => {
  try {
    const storage = JSON.stringify(state);

    await AsyncStorage.setItem(key, storage);
  } catch (error) {
    throw new Error(`fail save storage ${error}`);
  }
};

export const saveSecureStorage = async (state: any, key = "root-storage"): Promise<void> => {
  try {
    const storage = encrypt(state);

    await AsyncStorage.setItem(key, storage);
  } catch (error) {
    throw new Error(`fail save storage ${error}`);
  }
};

export const getSecureStorage = async (key = "root-storage"): Promise<any> => {
  try {
    const storage = await AsyncStorage.getItem(key);

    return storage === null ? undefined : decrypt(storage);
  } catch (error) {
    return undefined;
  }
};

export const removeStorage = async (key: string): Promise<void> => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    throw new Error(`fail remove storage ${error}`);
  }
};

export const clearStorage = async (): Promise<void> => {
  try {
    await AsyncStorage.clear();
  } catch (error) {
    throw new Error(`fail clear storage ${error}`);
  }
};
